<template>
    <div class="contenedor_modal">
        <div class="contenedor_modal_cuerpo">
            <div class="contenedor_modal_cabecera">
                <!-- <b-button type="button" size="sm" v-shortkey="['esc']" @shortkey="cerrar" variant="danger" -->
                <!-- @click="cerrar"><i class="fas fa-times"></i></b-button> -->
            </div>
            <b-container fluid class="p-3">
                <b-row>
                    <div class="col-sm-12 mb-3">
                        <h4>No Autorización</h4>
                    </div>
                    <div class="col-sm-12">
                        <input type="text" id="campo_registro_no_autorizacion" autocomplete="off"
                            class="form-control form-control-sm" v-model="no_autorizacion">
                    </div>
                    <div class="col-sm-12 mt-3">
                        <b-button v-if="accion == 'facturas'" type="button" size="sm" variant="outline-dark btn-block"
                            @click="guardar_no_autorizacion"><i class="fas fa-save"></i> Guardar y facturar</b-button>
                        <b-button v-else type="button" size="sm" variant="outline-dark btn-block"
                            @click="guardar_no_autorizacion"><i class="fas fa-save"></i> Guardar </b-button>
                    </div>
                </b-row>
            </b-container>
        </div>
    </div>
</template>

<script>
    import { minix } from '../functions/alertas'

    export default {
        name: 'ModalNoAutorizacion',
        props: ['accion'],
        data() {
            return {
                no_autorizacion: ''
            }
        },
        methods: {
            cerrar() {
                this.$emit('salir')
            },
            guardar_no_autorizacion() {
                if (this.no_autorizacion.length == 0 || this.no_autorizacion == '') {
                    minix({ icon: 'warning', mensaje: 'Ingresa el número de autorizacion', tiempo: 3000 })
                    document.getElementById('campo_registro_no_autorizacion').focus()
                } else {
                    this.$emit('guardar', this.no_autorizacion)
                    this.cerrar()

                }
            }
        },
        mounted() {
            document.getElementById('campo_registro_no_autorizacion').focus()
        },
    }
</script>

<style>
    /* Los estilos están definidos globalmente en Escritorio.vue */
    /* Si necesita estilos específicos para este componente, puede agregarlos aquí */
</style>